import { Fragment } from 'prosemirror-model'
import ReactDOM from 'react-dom'
import React from 'react'
import { TextSelection } from 'prosemirror-state'
import editorSchema from '../../schema/editorSchema'
import EquationEditorModal from '../../../components/richEditor/editorUI/modals/equationEditor/EquationEditorModal'
import analytics from '../../../utils/cdpAnalytics'

function closeModal() {
  ReactDOM.render(null, document.getElementById('equationEditorModal'))
}

export function openEquationEditorModal(openedWithShortcut, isAdvancedEditor, openedFromToolbar) {
  ReactDOM.render(
    <EquationEditorModal
      isNewNode
      mode={isAdvancedEditor ? 'advanced' : 'mathquill'}
      cancel={closeModal}
      openedWithShortcut={openedWithShortcut || false}
      insertMathNode={insertMathNodeWithLatex}
      initialLatex=''
      openedFromToolbar={openedFromToolbar}
    />,
    document.getElementById('equationEditorModal'),
  )
}

function insertMathNodeWithLatex(latex, openedWithShortcut, isAdvancedInput) {
  const { state } = window.view
  const { dispatch } = window.view
  const { empty, $from, $to } = state.selection
  // eslint-disable-next-line no-unused-vars
  let content = Fragment.empty
  if (!empty && $from.sameParent($to) && $from.parent.inlineContent) content = $from.parent.content.cut($from.parentOffset, $to.parentOffset)
  if (dispatch) {
    closeModal()
    const type = editorSchema.nodes.math
    const node = type.create({ latex, isAdvancedInput })
    const { tr } = state
    tr.replaceSelectionWith(node)
    const selection = new TextSelection(tr.doc.resolve($from.pos + node.nodeSize))
    tr.setSelection(selection) // position cursor after inserted stuff
    dispatch(tr)
    window.view.focus()
    analytics.track('Insert Equation', {
      latex,
      isAdvancedInput,
    })
  }
}

// export function insertEquation(openedWithShortcut){
//   openModal(insertMathNodeWithLatex,openedWithShortcut)
// }
